export default __webpack_public_path__ + "static/media/chef_hat.round.gold4.fe7a6c78.svg";